import * as React from 'react';
import type { SVGProps } from 'react';

const SvgParkingMarkerActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 38 53"
    {...props}
  >
    <rect width={38} height={38} fill="#5F59FF" rx={19} />
    <path
      fill="#fff"
      d="M15.877 27.25v-5.468h4.148c2.97 0 5.163-2.216 5.163-5.54 0-3.3-2.193-5.492-5.163-5.492h-7.212v16.5zm0-13.553h4.007c1.25 0 2.24.99 2.24 2.569 0 1.556-.99 2.569-2.24 2.569h-4.007z"
    />
    <path fill="#5F59FF" d="M17 37h4v16h-4z" />
  </svg>
);
export default SvgParkingMarkerActive;
